import type { QuotaReportsDataSource } from '@app/types/dataSource'
import type { ResponseDto } from '@app/api/dtos'
import type { QuotaReportsDto } from '@app/api/routes/quotaReports/dtos'
import type { FiltersParams } from '@app/types/filter'
import type { GetQuotaParams } from '@app/api/routes/quotaReports/types'

export const getQuotaReportsDataFromResponse = (
  response?: ResponseDto<QuotaReportsDto>
): QuotaReportsDataSource[] | undefined => {
  if (!response) return

  const rawData: QuotaReportsDto[] | undefined = response?.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    monitoringType: dto.monitoringType?.name ?? null,
    cluster: dto.cluster?.name ?? null,
    clustersGroup: dto.clustersGroup?.name ?? null,
    store: dto.store?.name ?? null,
    salesOrganization: dto.salesOrganization?.name ?? null,
    trend: dto.trend?.name ?? null,
    trendId: dto.trend?.id ?? null,
    purchasingGroup: dto.purchasingGroup?.name ?? null,
    purchasingGroupId: dto.purchasingGroup?.id ?? null,
    commodityGroup: dto.commodityGroup?.name ?? null,
    commodityGroupId: dto.commodityGroup?.id ?? null,
    category: dto.category?.name ?? null,
    categoryId: dto.category?.id ?? null,
    subcategory: dto.subcategory?.name ?? null,
    subcategoryId: dto.subcategory?.id ?? null,
    brandCount: dto.brandCount ?? null,
    brandProduct: {
      count: dto.brandProductsCount,
      status: dto.brandStatus
    },
    eppCount: dto.eppCount,
    eppChtmProduct: {
      count: dto.eppChtmProductsCount,
      status: dto.eppChtmStatus
    }
  }))
}

export const getFiltersDataFromQuotaReportTabFilters = (filters: FiltersParams): GetQuotaParams => {
  return {
    monitoringTypeIds: filters.monitoringTypeIds,
    storeIds: filters.storeIds,
    clusterIds: filters.clusterIds,
    clustersGroupIds: filters.clustersGroupIds,
    salesOrganizationIds: filters.salesOrganizationIds
  }
}
